import React from "react";
import { useStaticQuery, graphql } from "gatsby";

import PollenNavItem from "./PollenNavItem";
import PollenNavQuery from "../../../assets/StaticQueries/PollenNav.query";
import { CtaButton } from "../../RedesignComponents/Cta/cta-button";
import { mxpPrimaryCtaClicked } from "@utils/mixpanelEvents/mixpanelEvents";
import { marketingCtaClicked } from "@utils/segment/marketingCtaClicked";
import styles from "./MainPollenNavMenu.module.scss";

type MainPollenNavMenuType = {
  className?: string;
  isSticky: boolean;
};

const MainPollenNavMenu: React.FC<MainPollenNavMenuType> = ({
  className,
  isSticky,
}) => {
  const { categories } = PollenNavQuery();
  const label = "Start free trial";

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    mxpPrimaryCtaClicked(null!, label);

    marketingCtaClicked({
      text: label,
      url: window.location.pathname,
      target: e.currentTarget.pathname,
    });
  };

  const topicsList =
    categories &&
    categories.map(topic => (
      <PollenNavItem key={topic.id} path={topic.link} name={topic.name} />
    ));
  const ctaStyles = `${styles.pollenTrialCta} ${isSticky && styles.isSticky}`;

  return (
    <menu
      data-testid="topics-nav-items"
      className={`${styles.mainPollenNavMenu} ${className}`}
    >
      {topicsList}

      <li className={ctaStyles}>
        <CtaButton
          variant="primarySun"
          link={"/sign-up/"}
          copy={label}
          copySize="bodySmall"
          onClick={handleClick}
        />
      </li>
    </menu>
  );
};

export default MainPollenNavMenu;
